export default {
  data: function () {
    return {
      selectableOrderStatuses: [
        { text: '未応募', value: 0 },
        { text: '執筆中', value: 10 },
        { text: 'チェック中', value: 20 },
        { text: '検収中', value: 30 },
        { text: 'ライター校了', value: 40 },
        { text: 'クライアント検収中', value: 45 },
        { text: 'クライアント校了', value: 50 }
      ],
      orderStatuses: [
        { status: 'not_applied', value: 0 },
        { status: 'writing', value: 10 },
        { status: 'under_detection', value: 20 },
        { status: 'under_inspection', value: 30 },
        { status: 'completed', value: 40 },
        { status: 'under_client_inspection', value: 45 },
        { status: 'client_completed', value: 50 }
      ]
    }
  },
  methods: {
    writerCompleted (status) {
      return ['completed', 'client_completed'].includes(status)
    },
    isDeadOrder (order) {
      return !order.post && this.orderStatuses.find(e => e.status === order.status)['value'] < 40
    }
  }
}
